import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { BaseEditService, HttpService, NotificationService } from '../../../../tms-shared';
import { Address, AddressDetails, AddressLabel } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class AddressService extends BaseEditService<Address, AddressDetails> {
  public refreshDetails = new Subject<void>();
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('Address', $localize`Address`, httpService, notificationService);
  }

  getDeliveryAddress(id: string): Observable<AddressLabel> {
    return this.httpService.get<AddressLabel>(`${this.apiUrl}/GetDeliveryAddress?id=${id}`);
  }
}
